import { render, staticRenderFns } from "./accountsDeposit.vue?vue&type=template&id=63493ca6&"
import script from "./accountsDeposit.vue?vue&type=script&lang=js&"
export * from "./accountsDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports